import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-inventorymanagedetail',
  templateUrl: './inventorymanagedetail.component.html',
  styleUrls: ['./inventorymanagedetail.component.scss']
})
export class InventorymanagedetailComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
